import React, { useState, useEffect, useRef } from "react";
import "../styles/Profile.css";

const Profile = () => {
  const userToken = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("user");
  const fileInputRef = useRef(null);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [ubEmail, setUbEmail] = useState("");
  const [picture, setPicture] = useState("");
  const [responseMessage, setResponseMessage] = useState("");

  useEffect(() => {
    if (!userToken || !userId) {
      
      return;
    }

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_PATH}/users/${userId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch user data");

        const result = await response.json();
        if (result && result.attributes) {
          setUsername(result.attributes.username || "");
          setUbEmail(result.attributes.ubEmail || "");
          setPicture(result.attributes.picture || "");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        
      }
    };

    fetchUserData();
  }, [userToken, userId]);

  const submitHandler = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/users/${userId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          attributes: {
            username,
            ubEmail,
            picture,
          },
          password: password || undefined,
        }),
      });

      if (!response.ok) throw new Error("Failed to update profile");

      const result = await response.json();
      setResponseMessage(result.Status || "Profile updated successfully!");
    } catch (error) {
      console.error("Error updating profile:", error);
      
    }
  };

  const uploadPicture = async (event) => {
    event.preventDefault();
    const file = fileInputRef.current.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("uploaderID", userId);
    formData.append("attributes", JSON.stringify({}));
    formData.append("file", file);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}/file-uploads`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("File upload failed");

      const result = await response.json();
      const pictureURL = "https://webdev.cse.buffalo.edu" + result.path;
      setPicture(pictureURL);
    } catch (error) {
      console.error("Error uploading file:", error);
      
    }
  };

  return (
    <div className="profile-container">
      <img src={picture} alt="Profile" className="profile-picture" />
      <form onSubmit={submitHandler} className="profile-form">
        <label>
          Profile Picture
          <input type="file" accept="image/*" ref={fileInputRef} onChange={uploadPicture} />
        </label>
        <label>
          Username
          <input type="text" onChange={(e) => setUsername(e.target.value)} value={username} />
        </label>
        <label>
          UB Email
          <input type="email" onChange={(e) => setUbEmail(e.target.value)} value={ubEmail} />
        </label>
        <label>
          Password
          <input type="password" onChange={(e) => setPassword(e.target.value)} value={password} />
        </label>
        <button type="submit" className="submit-btn">Update Profile</button>
        <p>{responseMessage}</p>
      </form>
    </div>
  );
};

export default Profile;